/* Bolla spedizione — mercati fuori dall'Italia.
   In Italia lo snippet non stampa nulla, quindi qui non c'è mai niente da fare. */
(function () {
  'use strict';

  /* Stesso formato che usa il filtro `money` di Liquid, così nella stessa
     pagina non convivono «€87,77» e «29,10 €». */
  function conSeparatori(centesimi, decimali, separatoreMigliaia, separatoreDecimale) {
    var valore = (centesimi / 100).toFixed(decimali);
    var parti = valore.split('.');
    var interi = parti[0].replace(/\B(?=(\d{3})+(?!\d))/g, separatoreMigliaia);
    return parti[1] ? interi + separatoreDecimale + parti[1] : interi;
  }

  function importo(radice, centesimi) {
    var formato = radice.dataset.mdsFormato;

    // In euro il simbolo va dopo la cifra, come nel riquadro bundle.
    if ((radice.dataset.mdsValuta || '') === 'EUR') {
      return conSeparatori(centesimi, 2, '.', ',') + ' €';
    }

    if (formato && formato.indexOf('{{') !== -1) {
      return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, nome) {
        switch (nome) {
          case 'amount_no_decimals':
            return conSeparatori(centesimi, 0, ',', '.');
          case 'amount_with_comma_separator':
            return conSeparatori(centesimi, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return conSeparatori(centesimi, 0, '.', ',');
          case 'amount_with_apostrophe_separator':
            return conSeparatori(centesimi, 2, "'", '.');
          case 'amount_no_decimals_with_space_separator':
            return conSeparatori(centesimi, 0, ' ', ',');
          case 'amount_with_space_separator':
            return conSeparatori(centesimi, 2, ' ', ',');
          default:
            return conSeparatori(centesimi, 2, ',', '.');
        }
      });
    }

    // Senza formato dal tema: ripiego su Intl con la valuta del mercato.
    try {
      return new Intl.NumberFormat(radice.dataset.mdsLingua || 'it', {
        style: 'currency',
        currency: radice.dataset.mdsValuta || 'EUR'
      }).format(centesimi / 100);
    } catch (e) {
      return conSeparatori(centesimi, 2, '.', ',');
    }
  }

  function aggiorna(radice, totaleCentesimi) {
    if (!radice) return;

    var soglia = parseInt(radice.dataset.mdsSoglia, 10);
    var tariffa = parseInt(radice.dataset.mdsTariffa, 10) || 0;
    if (!soglia || soglia <= 0) return;

    var base = Math.max(0, Math.round(totaleCentesimi) || 0);
    var mancano = Math.max(0, soglia - base);
    var percentuale = Math.min(100, Math.round((base * 100) / soglia));

    var avanzamento = radice.querySelector('[data-mds-avanzamento]');
    if (avanzamento) avanzamento.style.width = percentuale + '%';

    var testo = radice.querySelector('[data-mds-testo]');
    if (testo) {
      if (mancano === 0) {
        testo.textContent = radice.dataset.mdsTestoOk || '';
      } else {
        testo.textContent = (radice.dataset.mdsTestoManca || '')
          .replace('{mancano}', importo(radice, mancano));
      }
    }

    var riga = radice.querySelector('[data-mds-riga]');
    if (riga) {
      riga.hidden = mancano === 0;
      if (mancano !== 0) {
        riga.textContent = (radice.dataset.mdsTestoRiga || '')
          .replace('{prezzo}', importo(radice, base))
          .replace('{spedizione}', importo(radice, tariffa));
      }
    }

    radice.classList.toggle('mds--raggiunta', mancano === 0);

    // Nel riquadro bundle parte nascosta: adesso i numeri sono quelli veri.
    radice.hidden = false;
  }

  /* Il riquadro bundle chiama questa: gli passa l'importo dopo lo sconto
     del gradino, che è quello su cui Shopify valuta davvero la soglia. */
  window.mdSpedizione = {
    aggiorna: aggiorna,
    aggiornaTutte: function (totaleCentesimi, dentro) {
      var ambito = dentro || document;
      var nodi = ambito.querySelectorAll('[data-mds]');
      for (var i = 0; i < nodi.length; i++) aggiorna(nodi[i], totaleCentesimi);
    }
  };

  /* Nel carrello l'importo lo prendiamo da Shopify dopo ogni modifica. */
  function riallineaDalCarrello() {
    var nelCarrello = document.querySelectorAll('[data-mds][data-mds-carrello]');
    if (!nelCarrello.length) return;

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (carrello) {
        if (!carrello) return;
        for (var i = 0; i < nelCarrello.length; i++) {
          aggiorna(nelCarrello[i], carrello.total_price);
        }
      })
      .catch(function () { /* se il carrello non risponde, resta il valore stampato da Liquid */ });
  }

  document.addEventListener('cart:updated', riallineaDalCarrello);
  document.addEventListener('cart:refresh', riallineaDalCarrello);
  document.addEventListener('cart-drawer:open', riallineaDalCarrello);
})();
